<nz-progress *ngIf="progress > 0" [nzPercent]="progress" nzType="circle" [nzWidth]="80"></nz-progress>
<div class="content" *ngIf="trace.length > 0">
  <h5 class="content-title"><i nz-icon [nzType]="icon" nzTheme="outline"></i>&nbsp;{{ title }}</h5>
  <div *ngFor="let log of trace"><span [class]="log.level">{{ log.message }}</span></div>
</div>
